import dayjs from 'dayjs';

export const utcDateStringToLocalDateFormat = (value: string) =>
    value ? dayjs.utc(value).local()?.format('YYYY-MM-DD HH:mm:ss') : '-';
